/* cc-float-video — floating video bubble on the PDP. Markup: sections/cc-float-video.liquid.
   Ported from the VaidicHerb founder bubble (2026-09-27). Bubble autoplays muted; tap opens
   the full clip MUTED; the unmute button is the only path to sound. */
(function () {
  'use strict';

  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function initFloatVideo(el) {
    var KEY = 'cc-fv-dismissed';
    try {
      if (sessionStorage.getItem(KEY) === '1') { el.remove(); return; }
    } catch (e) { /* private mode: just show it */ }

    var card = el.querySelector('[data-cc-fv-open]');
    var loop = el.querySelector('video');
    var closeBtn = el.querySelector('[data-cc-fv-close]');
    var modal = document.querySelector('[data-cc-fv-modal]');
    var full = modal && modal.querySelector('video');
    var fullSrc = el.getAttribute('data-full-src') || '';

    /* The theme's section wrappers can carry transforms/containment that would pin a
       position:fixed child to the section instead of the viewport. Live at <body>. */
    document.body.appendChild(el);
    if (modal) document.body.appendChild(modal);

    /* The clip's src is attached only after window load, so the bubble never competes with
       the product image / add-to-cart for bandwidth. The poster shows until then. */
    function reveal() {
      if (loop && !loop.getAttribute('src') && loop.getAttribute('data-src')) {
        loop.setAttribute('src', loop.getAttribute('data-src'));
        if (!reduced) { var rp = loop.play(); if (rp && rp.catch) rp.catch(function () {}); }
      }
      el.classList.add('is-in');
    }
    if (document.readyState === 'complete') setTimeout(reveal, 400);
    else window.addEventListener('load', function () { setTimeout(reveal, 400); });

    /* Muted autoplay now; if refused (iOS Low Power Mode refuses even muted video),
       retry on the visitor's first gesture. */
    if (loop && !reduced) {
      var started = false;
      var start = function () {
        if (started) return;
        var pr = loop.play();
        if (pr && pr.then) pr.then(function () { started = true; }).catch(function () {});
        else started = true;
      };
      var GESTURES = ['touchstart', 'pointerdown', 'scroll', 'keydown'];
      var onGesture = function () {
        start();
        if (started) GESTURES.forEach(function (g) { window.removeEventListener(g, onGesture); });
      };
      GESTURES.forEach(function (g) { window.addEventListener(g, onGesture, { passive: true }); });
    }

    var lastFocus = null;

    function openModal() {
      if (!modal || !full) return;
      lastFocus = document.activeElement;
      /* preload="none" until here - the full clip is only fetched on intent. */
      if (fullSrc && full.getAttribute('src') !== fullSrc) full.setAttribute('src', fullSrc);
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (loop) loop.pause();
      try { full.currentTime = 0; } catch (e) {}
      full.muted = true;
      var unmute = modal.querySelector('[data-cc-fv-unmute]');
      if (unmute) unmute.hidden = false;
      var p = full.play();
      if (p && p.catch) p.catch(function () { full.controls = true; });
      var c = modal.querySelector('[data-cc-fv-modal-close]');
      if (c) c.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (full) { full.pause(); full.muted = true; }
      if (loop && !reduced) {
        var p = loop.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (card) {
      card.addEventListener('click', openModal);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); openModal(); }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        el.classList.remove('is-in');
        setTimeout(function () { el.remove(); }, 400);
        try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      });
    }

    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      var mc = modal.querySelector('[data-cc-fv-modal-close]');
      if (mc) mc.addEventListener('click', closeModal);

      var unmuteBtn = modal.querySelector('[data-cc-fv-unmute]');
      if (unmuteBtn && full) {
        unmuteBtn.addEventListener('click', function () {
          full.muted = false;
          full.volume = 1;
          var pp = full.play();
          if (pp && pp.catch) pp.catch(function () {});
          unmuteBtn.hidden = true;
        });
      }

      var buy = modal.querySelector('[data-cc-fv-buy]');
      if (buy) {
        buy.addEventListener('click', function () {
          closeModal();
          /* Send them to the REAL buy box - never a second, parallel buy path. */
          var target = document.querySelector('.product-info__buy-buttons') ||
                       document.querySelector('buy-buttons') ||
                       document.querySelector('form[action*="/cart/add"]');
          if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }
  }

  /* Mirror the quick-add bar's visibility onto <html> (.cc-qa-up) with its measured
     height (--cc-qa-h), so on mobile the bubble rests low and lifts only while the
     full-width bar is actually on screen. */
  function trackQuickAdd() {
    var bar = document.querySelector('product-quick-add');
    if (!bar) return;
    var root = document.documentElement;
    var sync = function () {
      var up = bar.classList.contains('is-visible');
      if (up) root.style.setProperty('--cc-qa-h', Math.round(bar.getBoundingClientRect().height) + 'px');
      root.classList.toggle('cc-qa-up', up);
    };
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function boot() {
    var fv = document.querySelector('[data-cc-fv]');
    if (!fv) return;
    trackQuickAdd();
    initFloatVideo(fv);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
